
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id_utilisateur"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_categorie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"designation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_template"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geolocalisation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cout_gold_sup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_ad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_destockage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montant_minimum_promo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_zone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code_postal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commune"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"races"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_race"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nom"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"marques"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifiant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"libelle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"modeles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_modele"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifiant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"libelle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marque_vehicule"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":700}};
    doc.loc.source = {"body":"query ($id_utilisateur: ID) {\n    addFilter(id_utilisateur: $id_utilisateur){\n        categories{\n            pk_categorie\n            designation\n            fk_template\n            statut\n            geolocalisation\n            cout_gold_sup\n            etat\n            id_ad\n            prix_destockage\n            montant_minimum_promo\n        }\n        zones{\n            pk_zone\n            code_postal\n            commune\n        }\n        races{\n            pk_race\n            nom\n        }\n        marques{\n            identifiant\n            libelle\n        }\n        modeles{\n            pk_modele\n            identifiant\n            libelle\n            marque_vehicule\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
